import {Detail, Risorsa} from './_Index';
import {TipoUmTempo} from '../_helpers/TipoUmTempo';

export class OrdineEsolver extends Detail {
  dbgruppo: string;
  idDocumento: number;
  dataRegistrazione: Date;
  numRegistrazione: number;
  idRiga: number;
  codiceArticolo: string;
  descArt: string;
  varianteArt?: string;
  idRigaLavorazione: number;
  lavorazione: string;
  desLavorazione: string;
  stato: number;
  quantita: number;
  risorsa: string;
  risorsaLocale?: Risorsa;
  reparto: string;
  desRisorsa: string;
  dataTermine: Date;
  hasErrors: boolean;
  hasWarnings: boolean;

  saldato: boolean;
  //rifOrdine: string;
  quantitaLavorata: number;
  quantitaScartata: number;
  tempo: string;
  qtaOrdine: number;
  commessa?: string;
  umTempo?: TipoUmTempo;
  quantitaOrdinataUdM2?: number;

  codMagPrincipale?: string;
  codAreaMagPrinc?: string;

  rifLottoAlfanum: string;
  udM: string;
  udM2?: string;
  rifOdP?: string;
  numFase: number;

  id?: number;
  idOrdVen?: number;
  numRegistrazOrdVen?: number;
  numDocOriginaleOrdVen?: string;
  rifOrdVen?: string;
  codCliente?: number;
  ragSocialeCliente?: string;
  faseContoLavoro?: number;
  codTerzista?: number;
  ragSocialeTerzista?: string;
  notaInterna?: string;
  notaFase?: string;

  rifOrdine?: string;

  lastFase?: number;
}
